// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FEED_DISPLAY_MORE = "Zobraz dal\u0161\u00ed";
